<template>
  <v-container fluid grid-list-sm style="padding: 8px;">
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
        :footer-props="globalFooterOptions"
        :headers="headers"
        :items="items"
        :items-per-page="globalItemsPerPage"
        :loading="loading"
        no-data-text="No Pending Actions"
        :options.sync="options"
        :server-items-length="totalItems"
        class="elevation-1"
        style="margin-bottom: 80px;"
        >
          <template v-slot:item.type="{ item }" >{{ translateAction(item.type) }}</template>
          <template v-slot:item.timeCreated="{ item }" >{{ formatDateTime(item.timeCreated) }}</template>
          <template v-slot:item.approver="{ item }" >{{ getApprover(item) }}</template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>

</template>

<script>
import ApiRequests from '@/api/ApiRequests'
import ErrorSnackbar from '@/components/ErrorSnackbar'
import { mapGetters } from 'vuex'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      headers: [
        { text: 'Type', value: 'type' },
        { text: 'Approver', value: 'approver', sortable: false },
        { text: 'Created', value: 'timeCreated' }
      ],
      errorText: '',
      items: [],
      loading: false,
      options: {},
      totalItems: 0
    }
  },

  created () {
    this.getData()
  },

  computed: {
    ...mapGetters([
      'selectedSite'
    ])
  },

  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true
    }
  },

  methods: {
    getApprover: function (item) {
      if (item.type === 'actionSiteInvite') {
        return item.approverName
      }
      return item.creatorName
    },

    getData: function () {
      if (this.options.page !== undefined) {
        this.loading = true

        var params = {}
        if (this.options.itemsPerPage > 0) {
          params.page = this.options.page - 1
          params.limit = this.options.itemsPerPage
        }

        if (this.options.sortBy.length > 0) {
          params.sort = ''
          if (this.options.sortDesc[0]) {
            params.sort = '-'
          }
          params.sort = params.sort + this.options.sortBy[0]
        }

        params.creator = this.selectedSite._id

        ApiRequests.actionQuery(params).then(r => {
          this.items = r.data
          this.totalItems = parseInt(r.headers['x-total-count'])
          this.loading = false
        })
      }
    }
  }
}
</script>
